import { Box } from '@mui/material';

import { Review } from '@/graphql/__generated/sdk';

import { reviewsListContainer, reviewListItem } from './ReviewsList.styles';
import { ReviewItem } from './ReviewItem';

export default function ReviewsList({ reviews }: { readonly reviews?: Review[] }) {
	const displayReviews = reviews ?? [];

	return (
		<Box sx={reviewsListContainer}>
			{displayReviews.map((review) => (
				<Box key={review.reviewId} sx={reviewListItem}>
					<ReviewItem review={review} />
				</Box>
			))}
		</Box>
	);
}
